import type { ReactNode } from 'react';

export const symbol_rotate_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M156-488q-15 0-24-11t-6-25q7-32 18-60.5t27-54.5q8-13 22-14.5t25 9.5q8 8 9 19t-4 20q-14 23-23.5 46T185-512q-2 10-10.5 17t-18.5 7Zm278 372q0 15-11 24t-25 6q-29-7-57.5-18T285-132q-13-8-14.5-22t9.5-25q8-8 18.5-8.5T318-183q23 14 46 23.5t46 14.5q10 2 17 10.5t7 18.5ZM218-242q-11 11-24.5 9.5T172-247q-15-26-26-55t-19-61q-3-14 5.5-24.5T156-398q11 0 19 7t10 17q5 24 14 47t23 46q5 9 4 20.5t-8 18.5ZM559-86q-14 3-25-6t-11-24q0-11 7-19.5t17-10.5q101-26 166-106.5T778-443q0-127-86.5-213.5T478-743h-20l57 57q9 9 9 22t-9 22q-9 9-22 9t-22-9L361-752q-5-5-7-10t-2-11q0-6 2-11t7-10l110-110q9-9 22-9t22 9q9 9 9 22t-9 22l-57 57h20q151 0 255.5 104.5T838-443q0 131-78 230T559-86Z"
		/>
	</svg>
);
